








import { defineComponent, nextTick, onMounted, onUpdated, ref } from '@vue/composition-api';

export default defineComponent({
  name: 'BaseBreadcrumb',
  props: {
    collapseAt: {
      default: 5,
      type: Number,
    },
  },
  setup(props) {
    const breadcrumbInner = ref<HTMLDivElement>();
    const breadcrumb = ref<HTMLDivElement>();

    const addAttributesToChildren = () => {
      const items = breadcrumb.value.querySelectorAll(`.breadcrumb-item`);
      items.forEach((item: HTMLDivElement) => {
        item.removeAttribute('first');
        item.removeAttribute('aria-current');
      });

      if (items.length) {
        items[0].setAttribute('first', '');
        items[items.length - 1].setAttribute('aria-current', '');
      }

      if (items.length > props.collapseAt) {
        hideMiddleElements();
      } else {
        showMiddleElements();
      }
    };

    const hideMiddleElements = () => {
      const items = breadcrumb.value.querySelectorAll(`.breadcrumb-item`);
      const middleItems = [...items].slice(1, items.length - 2);
      middleItems[0].setAttribute('second', '');
      middleItems.forEach((item: HTMLDivElement) => {
        item.setAttribute('middle', '');
      });
    };

    const showMiddleElements = () => {
      const items = breadcrumb.value.querySelectorAll(`.breadcrumb-item`);
      items.forEach((item: HTMLDivElement) => {
        item.removeAttribute('second');
        item.removeAttribute('middle');
      });
    };

    onUpdated(() => {
      addAttributesToChildren();
    });
    onMounted(async () => {
      await nextTick();
      addAttributesToChildren();
    });

    return {
      breadcrumb,
      breadcrumbInner,
    };
  },
});
